import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'environments/environment';
import { Access } from '../models';

@Injectable({ providedIn: 'root' })
export class AccessService {
  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  /**
   * Get all access
   */
  getAll() {
    return this._http.get<Access[]>(`${environment.commonApiUrl}/api/access-type`);
  }

}
